module.exports = __webpack_public_path__ + "img/stl-home.849d9fdb.jpg";